var PageData = React.createContext({});
export var PageDataProvider = PageData.Provider;
export var PageDataConsumer = PageData.Consumer;
export default PageData;